import { Typography } from "@mui/material";
import Box from "@mui/material/Box/Box";
import styled from "styled-components";

export const SwitchContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const PaymentOptions = styled(Box)`
  display: flex;
  flex-direction: column;
`;

export const Title = styled(Typography)`
  color: rgba(0, 0, 0, 0.64);
  font-family: "NotoSans-Regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`;
